import React, { FC } from "react";
import styles from "./line.module.scss";

const Line: FC = () => <div className={styles.line} />;

export default Line;
